module.exports = __webpack_public_path__ + "static/img/slider-5.c9d8c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-5.jpg
// module id = Aotk
// module chunks = 7